/**
 * L6.3 — Campos de escala gravados em todo save do painel.
 * Reutiliza utils/gerarPalavrasBusca.ts (mesma regra do script L6.2).
 */
import type { Product } from '../types';
import {
  gerarNomeLower,
  gerarPalavrasBusca,
  nomeProdutoTexto,
} from './gerarPalavrasBusca';

/** ativo = (available !== false) && (isPaused !== true) */
export function derivarAtivoProduto(p: {
  available?: boolean;
  isPaused?: boolean;
}): boolean {
  return p.available !== false && p.isPaused !== true;
}

/**
 * Garante ativo, nomeLower, palavrasBusca e ordem (9999 se ausente).
 * Não remove available/isPaused nem outros campos.
 */
export function enrichProductL6Fields(product: Product): Product {
  const nome = nomeProdutoTexto(product.name);
  const ordem =
    typeof product.ordem === 'number' && Number.isFinite(product.ordem)
      ? product.ordem
      : 9999;

  return {
    ...product,
    ativo: derivarAtivoProduto(product),
    ordem,
    nomeLower: gerarNomeLower(nome),
    palavrasBusca: gerarPalavrasBusca(nome),
  };
}

/**
 * Merge seguro para update parcial: base completa + patch.
 * Ex.: só mudou o nome de um pausado → isPaused/available vêm do existente,
 * então ativo permanece false.
 */
export function mergeAndEnrichProductL6(
  existing: Product | null | undefined,
  patch: Product
): Product {
  const merged = {
    ...(existing || {}),
    ...patch,
    id: patch.id,
  } as Product;
  return enrichProductL6Fields(merged);
}

/** Só os 4 campos L6 — para cadastros que não devem alterar o payload legado. */
export function onlyL6SearchFields(product: Product): {
  ativo: boolean;
  ordem: number;
  nomeLower: string;
  palavrasBusca: string[];
} {
  const enriched = enrichProductL6Fields(product);
  return {
    ativo: enriched.ativo === true,
    ordem: enriched.ordem ?? 9999,
    nomeLower: enriched.nomeLower || '',
    palavrasBusca: enriched.palavrasBusca || [],
  };
}
